import React, {Component} from 'react';
import Nav from '../Nav';
// import Video from '../Video';
import HomeMessage from './home-message';
import './home.scss';
import withAuth from "../../services/withAuth";

import AuthService from "../../services/authService";
import VideoPlayerComponent from '../Video'

class HomePage extends Component {
    constructor(props, context) {
        super(props, context);
        // console.log('the props being sent HOME are: ', props)

        this.state = {
            completed: false,
            showMenu: false,

        }
        this.videoSource = {
            src: 'https://d3ug1m98su9wd.cloudfront.net/be331579-30fa-46d9-8386-a35b5d8e879b/hls/HEA __ customer dsahboard welcome (1).m3u8',
        }
    }

    componentDidMount() {
        this.checkQuestionsCompleted(AuthService.getUser())
    }

    checkQuestionsCompleted(user) {
        let userObject = JSON.parse(user);
        // If the user has completed the questions unlock the menu
        if (userObject.category_order) {
            this.setState({
                completed: true,
            })
        }

        this.checkUserProgress(userObject.progress);
        // this.setState({
        //     completed: userObject.category
        // });
        // console.log('completed', status);
    }
    checkUserProgress(array){
            array.forEach(e => e.reviewed || e.watched ? this.props.history.push('/progress'): "")
    }

    handleClick = (e) => {
        // console.log("click triggered",e.target);
        this.setState({
            showMenu: !this.state.showMenu
        })
    }

    handleClose = (e) => {
        let target = e.target;

        if (target.classList.contains('large-text') || target.classList.contains('menu-list') || target.classList.contains('small-text') || target.classList.contains('social-icon') || target.classList.contains('menu-slideout') || target.classList.contains('menu-button')) {
            return;
        }

        // if (target.classList.contains('close-menu')){
        if (this.state.showMenu) {
            this.setState({
                showMenu: false
            })
        }
        // }
        // console.log("close triggered" ,e.target);
    }

    render() {
        if (!this.state.completed) {
            return (
                <div className="homepage" onClick={this.handleClose}>
                    <Nav checkQuestionsCompleted={this.checkQuestionsCompleted} completed={this.state.completed}
                         showMenu={this.state.showMenu} handleClick={this.handleClick} handleClose={this.handleClose}/>
                    <div id="video-container">
                        <VideoPlayerComponent {...this.videoSource} tutorial={false}/>
                    </div>
                    <HomeMessage
                        text={"Get started by taking the relationship assessment with your fiance. This quiz is meant to be taken as a couple, not individually. Results of the assessment will help us tailor the content for the both of you!"}
                        returning={false}/>
                </div>
            );
        } else {
            return (
                <div className="homepage" onClick={this.handleClose}>
                    <Nav checkQuestionsCompleted={this.checkQuestionsCompleted} completed={this.state.completed}
                         showMenu={this.state.showMenu} handleClick={this.handleClick} handleClose={this.handleClose}/>
                    <div id="video-container">
                        <VideoPlayerComponent {...this.videoSource} tutorial={false}/>
                    </div>
                    <HomeMessage
                        text={"Welcome back!"}
                        returning={true}/>
                </div>
            );
        }

    }

}

export default withAuth(HomePage);
